import { useNavigate } from "react-router";
import { buttonClass } from "./Button";

interface BackButtonProps {
  /**
   * The screen back goes to. Always this one, never the browser history: the label names it ("Back to my steps"), and
   * popping history took people to whatever they saw last, e.g. Finance Step 5 after finishing it and moving to Step 6.
   */
  to?: string | undefined;
  label?: string | undefined;
}

/** The one back control, so every screen's looks and behaves the same. */
export function BackButton({ to = "/hub", label = "Back" }: BackButtonProps) {
  const navigate = useNavigate();
  return (
    <button type="button" onClick={() => void navigate(to)} className={buttonClass("ghost")}>
      ← {label}
    </button>
  );
}
